import { SubmitData } from '@shared/utils';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import * as Sentry from '@sentry/react';

import { useDrainsStore } from './useDrainsStore';
import { RoutesList } from '../routes/Routes';

export interface UseHandleSubmitOptions {
  confirmationRoute: string;
  endpoint: string;
}

export const useHandleSubmit = ({
  confirmationRoute,
  endpoint,
}: UseHandleSubmitOptions) => {
  const navigate = useNavigate();
  const { update } = useDrainsStore();

  return useMutation({
    mutationFn: (variables: { payload: any; isLoggedInUser: any }) =>
      SubmitData({ ...variables, endpoint }),
    onSuccess: (data) => {
      update('confirmation', data);
      navigate(confirmationRoute);
    },
    onError: (error) => {
      Sentry.captureException(error);
      navigate(RoutesList.INTERNAL_SERVER_ERROR);
    },
  });
};
